// Tickable Mail: inbox, huisstijl & afzender, bestelling en reserveren (nl)
export default {
  // Inbox
  "mail_inbox_intro": "Reageert iemand op een mail? Dan komt het hier binnen, met de bestelling erbij.",
  "mail_inbox_classic": "Berichten horen bij je eigen mails. Nu gaan reacties nog naar je eigen e-mailadres, als je dat hebt ingevuld.",
  "mail_inbox_classic_link": "Bekijk wat eigen mails je geven",
  "mail_inbox_filter": "Welke berichten",
  "mail_inbox_filter_open": "Open",
  "mail_inbox_filter_done": "Afgehandeld",
  "mail_inbox_filter_all": "Alles",
  "mail_inbox_empty": "Nog geen berichten. Reacties op je mails komen hier binnen.",
  "mail_inbox_empty_open": "Niks meer open. Lekker bezig!",
  "mail_inbox_empty_done": "Nog niks afgehandeld.",
  "mail_inbox_pick": "Kies links een gesprek.",
  "mail_inbox_thread_gone": "Dit gesprek bestaat niet (meer).",
  "mail_inbox_unread": "Ongelezen",
  "mail_inbox_just_now": "zojuist",
  "mail_inbox_no_subject": "(geen onderwerp)",
  "mail_inbox_message": "Bericht",
  "mail_inbox_no_messages": "Er staan nog geen berichten in dit gesprek.",
  "mail_inbox_you": "Jij",
  "mail_inbox_mark_done": "Afgehandeld",
  "mail_inbox_reopen": "Weer openen",
  "mail_inbox_status_failed": "Dat lukte niet",
  "mail_inbox_order": "bestelling",
  "mail_inbox_order_of": "Bestelling van {name}",
  "mail_inbox_order_unpaid": "nog niet betaald",
  "mail_inbox_ticket_count": "{count} ticket | {count} tickets",
  "mail_inbox_resend_tickets": "Tickets opnieuw sturen",
  "mail_inbox_contact_consent": "Bezoeker, heeft toestemming gegeven voor nieuwsmail",
  "mail_inbox_contact_no_consent": "Bezoeker, zonder toestemming voor nieuwsmail",
  "mail_inbox_attachment_not_stored": "bijlage niet opgeslagen",
  "mail_inbox_reply_to": "Antwoord aan {email}",
  "mail_inbox_reply_hint": "Ctrl + Enter verstuurt ook",
  "mail_inbox_send": "Versturen",
  "mail_inbox_send_failed": "Je antwoord is niet verstuurd",
  "mail_inbox_send_failed_detail": "Je tekst staat er nog. Probeer het zo nog een keer.",
  "mail_inbox_no_write_right": "Je kunt dit gesprek lezen, maar niet beantwoorden. Vraag de eigenaar van je organisatie om het recht 'E-mail bewerken'.",

  // Huisstijl & afzender
  "mail_settings_intro_on": "Hoe je mails eruitzien, van wie ze komen en wat je bezoekers in de shop aanvinken.",
  "mail_settings_intro_classic": "Je mails gaan nog op de klassieke manier. Toestemming verzamelen in je shop kan nu al, zodat je straks een lijst hebt.",
  "mail_settings_read_only": "Je kunt deze instellingen bekijken, maar niet aanpassen.",
  "mail_settings_save": "Opslaan",
  "mail_settings_save_failed": "Opslaan lukte niet",
  "mail_settings_unsaved": "Je hebt wijzigingen die nog niet zijn opgeslagen. Toch weggaan?",
  "mail_settings_consent_title": "Toestemming in je shop",
  "mail_settings_consent_description": "Kopers kunnen bij het afrekenen aangeven dat ze nieuws van je willen. Het vakje staat nooit vooraf aangevinkt.",
  "mail_settings_consent_toggle": "Vraag om toestemming bij het afrekenen",
  "mail_settings_consent_label": "Tekst naast het vakje",
  "mail_settings_consent_default": "Houd mij op de hoogte van nieuwe activiteiten van {name}",
  "mail_settings_consent_label_help": "Laat je dit leeg, dan staat de tekst hierboven erbij.",
  "mail_settings_consent_label_needs_name": "Zet je naam ({name}) in de tekst, zodat kopers weten van wie ze mail krijgen.",
  "mail_settings_consent_preview": "Zo ziet het eruit in je shop",
  "mail_settings_languages_title": "Talen",
  "mail_settings_languages_description": "In welke talen je mails (en straks je shop) er zijn. Kopers krijgen hun mail in de taal waarin ze bestelden.",
  "mail_settings_languages": "Talen",
  "mail_settings_source_language": "Brontaal",
  "mail_settings_source_language_help": "Hierin schrijf je. Ontbreekt een vertaling, dan krijgt de koper deze taal.",
  "mail_settings_sender_title": "Afzender",
  "mail_settings_sender_description": "Van wie je mails komen en waar reacties heen gaan.",
  "mail_settings_sender_name": "Afzendernaam",
  "mail_settings_sender_preview": "Je mails komen van {address}. Reacties komen binnen bij Berichten.",
  "mail_settings_postal_address": "Postadres",
  "mail_settings_postal_address_help": "Een nieuwsmail moet volgens de wet een postadres van de afzender hebben. Zonder adres kun je geen nieuwsbrieven versturen.",
  "mail_settings_attach_pdf": "Tickets ook als pdf-bijlage meesturen",
  "mail_settings_attach_pdf_help": "Hoeft meestal niet: in elke mail staat een knop naar de bestelpagina met alle tickets. Zonder bijlage komen mails ook beter aan. Zet het aan als je bezoekers scannen op een plek zonder bereik.",
  "mail_settings_brand_title": "Huisstijl",
  "mail_settings_consent_label_add": "Tekst aanpassen",
  "mail_settings_sender_name_add": "Afzendernaam aanpassen",
  "mail_settings_postal_address_add": "Postadres toevoegen",
  "mail_settings_attach_pdf_add": "Tickets als PDF meesturen",
  "mail_settings_brand_add": "Eigen huisstijl voor mails",
  "mail_settings_logo_dark_add": "Logo voor donkere modus",
  "mail_settings_font_add": "Lettertype",
  "mail_settings_brand_description": "Je logo, kleuren en lettertype in elke mail. Zonder eigen keuze gebruiken we de huisstijl van de activiteit, anders die van je shop.",
  "mail_settings_logo": "Logo",
  "mail_settings_logo_upload": "Logo uploaden",
  "mail_settings_logo_advice": "Een png met transparante achtergrond werkt het best. Maximaal 1 MB.",
  "mail_settings_logo_dark": "Logo voor donkere modus (mag leeg)",
  "mail_settings_logo_dark_advice": "Een lichte versie, voor mailprogramma's in donkere modus.",
  "mail_settings_logo_background": "Logo op een eigen vlak",
  "mail_settings_accent": "Accentkleur",
  "mail_settings_background": "Achtergrond",
  "mail_settings_card_color": "Blokken",
  "mail_settings_text_color": "Tekstkleur",
  "mail_settings_font": "Lettertype",
  "mail_settings_brand_from_shop": "Neem over uit je shop",
  "mail_settings_domain_title": "Mailen vanaf je eigen domein",
  "mail_settings_domain_offer": "Mail vanaf tickets{'@'}jouwfestival.nl",
  "mail_settings_domain_explain": "Je mailbox blijft gewoon werken: je zet er alleen een paar DNS-records bij. We bouwen dit zodra genoeg organisatoren het willen.",
  "mail_settings_domain_interest": "Ik heb interesse",
  "mail_settings_domain_noted": "We nemen contact met je op. Je gaf je interesse door op {date}.",
  "mail_settings_quota": "Gratis mail je tot {limit} bezoekers met toestemming. Je hebt er nu {count}.",
  "mail_settings_classic_description": "Je ticketmails gaan dan weer in de vaste opmaak. Er wordt niks verwijderd: je ontwerpen, automatische mails en inbox staan er nog als je terugkomt.",
  "mail_settings_classic_button": "Terug naar klassiek",
  "mail_settings_classic_confirm_title": "Terug naar klassiek?",
  "mail_settings_classic_confirm": "Automatische mails en nieuwsbrieven stoppen, en je ticketmails krijgen weer de vaste opmaak. Je kunt je eigen mails later gewoon weer aanzetten.",

  // Bestelling
  "mail_order_mail": "Mail",
  "mail_order_resent": "Tickets zijn onderweg",
  "mail_order_resent_to": "We sturen ze opnieuw naar {email}.",
  "mail_order_resend_failed": "Opnieuw sturen lukte niet",
  "mail_order_resend_failed_detail": "Probeer het zo nog een keer. Blijft het misgaan? Laat het ons weten.",

  // Reserveren
  "mail_reservation_event": "Activiteit",
  "mail_reservation_timeslot": "Tijdslot",
  "mail_reservation_pick_timeslot": "Kies een tijdslot",
  "mail_reservation_tickets": "Tickets",
  "mail_reservation_no_ticket_types": "Er zijn geen tickettypes voor deze activiteit of dit tijdslot.",
  "mail_reservation_total": "{count} ticket | {count} tickets",
  "mail_reservation_name": "Naam",
  "mail_reservation_email": "E-mailadres",
  "mail_reservation_email_invalid": "Vul een geldig e-mailadres in, daar gaat de betaallink heen.",
  "mail_reservation_language": "Taal van de mail",
  "mail_reservation_deadline": "Betalen binnen",
  "mail_reservation_days": "{count} dag | {count} dagen",
  "mail_reservation_deadline_until": "Tot {date}",
  "mail_reservation_need_timeslot": "Kies een tijdslot.",
  "mail_reservation_need_tickets": "Kies minstens één ticket.",
  "mail_reservation_cancel": "Annuleren",
  "mail_reservation_done": "Reservering gemaakt, de betaallink is onderweg naar {email}.",
  "mail_reservation_link": "Betaallink",
  "mail_reservation_link_help": "Je kunt hem ook zelf sturen. Hij werkt tot {date}.",
  "mail_reservation_open_order": "Bekijk bestelling",
  "mail_reservation_close": "Sluiten",
}
